import React from 'react';
import { useForm } from 'react-hook-form';
import Skeleton from 'react-loading-skeleton';
import { ModalSidebarFormContent } from '../../../components/ModalSidebar';
import {
  WorkflowItemDataRequest,
  WorkflowItemStatus,
} from '../WorkflowItems/types';
import { WorkflowItemCommonFields } from './WorkflowItemCommonFields';
import { WorkflowItemSubmitButton } from './WorkflowItemSubmitButton';
import { WorkflowItemStatusField } from './WorkflowItemStatusField/WorkflowItemStatusField';

type Props = {
  workflowItem: WorkflowItemDataRequest;
};

type FormData = {
  status: WorkflowItemStatus;
};

export const WokflowItemDataRequestLoading: React.FC<Props> = ({
  workflowItem,
}) => {
  const { status } = workflowItem;

  const defaultValues: FormData = {
    status,
  };

  const form = useForm<FormData>({
    defaultValues,
  });

  return (
    <ModalSidebarFormContent
      form={form}
      onSubmit={() => {}}
      body={
        <>
          <WorkflowItemCommonFields workflowItem={workflowItem} />
          <WorkflowItemStatusField
            name="status"
            readonlyStatus={status}
            readonly={workflowItem.readonly}
          />
          <LoadingDataFields count={workflowItem.dataFieldNames.length} />
        </>
      }
      footerClassName="flex-column"
      footer={<WorkflowItemSubmitButton disabled={true} />}
    />
  );
};

const LoadingDataFields: React.FC<{ count: number }> = ({ count }) => {
  return (
    <>
      {Array.from(Array(count).keys()).map((key) => (
        <div key={key}>
          <Skeleton width={120} height={16} style={{ marginBottom: 10 }} />
          <Skeleton height={40} style={{ marginBottom: 20 }} />
        </div>
      ))}
    </>
  );
};
